<form #form="ngForm" autocomplete="off">
    <ui-banner *ngIf="pendingPayrollExists" class="margin-bottom-3" variant="warning">
        {{ 'employees.jobAndPay.pendingPayroll.cannotModifyVacationPayMethod' | translate }}
    </ui-banner>
    <div *ngIf="employee" class="responsive-grid">
        <mat-label>{{ 'employees.jobAndPay.howToPayOutVacationPay' | translate }}:</mat-label>
        <br />
        <mat-radio-group
            name="employeeVacationPayMethodOptions"
            [(ngModel)]="employeeVacationPayMethod"
            [disabled]="pendingPayrollExists"
            class="vertical"
            required
        >
            <mat-radio-button value="vacation_accrual" class="margin-bottom-1">{{
                'employees.jobAndPay.accruedVacationPayWillBeBankedInHumiAndBePaidOutWhenThisEmployeeTakesVacation'
                    | translate
            }}</mat-radio-button>
            <mat-radio-button value="vacation_cash">{{
                'employees.jobAndPay.payoutAccruedVacationPay' | translate
            }}</mat-radio-button>
        </mat-radio-group>
    </div>
</form>
